import { ClientCustomCalendarModel } from '../../../../models';
import { getEndMonthDate } from '../../../../util';
import { getCustomCalendarPeriodEndDate } from '../../../../util/customCalendarPeriods';
import { ReportSettingStartEndState } from '../StartEnd';

export const getReportEndDateStartEnd = (
  reportSettingState: ReportSettingStartEndState,
  customCalendarSettings: ClientCustomCalendarModel,
): Date => {
  const { rollforwardThrough } = reportSettingState;
  // if custom calendar client, do not get last day of month, use endDate as is
  if (customCalendarSettings.isCustomCalendarEnabled) {
    return getCustomCalendarPeriodEndDate(
      rollforwardThrough,
      customCalendarSettings,
    );
  }

  return getEndMonthDate(rollforwardThrough);
};
